import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { TextArea } from '@seeqdev/qomponents';
import { focusAndSelectElement } from '@/utilities/dom.utilities';

export type ItemDescriptionProps = {
  canWrite: () => boolean;
  originalDesc: string;
  updateDescription: (description: string) => Promise<void>;
  isWorkbookLocked: boolean;
};

export const ItemDescription = ({
  canWrite,
  originalDesc,
  updateDescription,
  isWorkbookLocked,
}: ItemDescriptionProps) => {
  const { t } = useTranslation();

  const [description, setDescription] = useState(originalDesc);

  useEffect(() => {
    setDescription(originalDesc);
  }, [originalDesc]);

  return (
    <dl data-testid="itemDescription" className="dl-striped-reversed dl-horizontal-indented properties-list">
      {canWrite() && (
        <div className="striped propList__item" data-testid="descriptionContainer">
          <dt className="mb0 striped propList__item__name">{t('DESCRIPTION')}</dt>
          <dd className="propList__item__value">
            <TextArea
              extraClassNames="min-height-18 mb5"
              id="specDescription"
              testId="specDescription"
              value={description ?? ''}
              onChange={(e) => setDescription(e.target.value)}
              onFocus={focusAndSelectElement}
              onBlur={() => updateDescription(description)}
              rows={4}
              disabled={isWorkbookLocked}
            />
          </dd>
        </div>
      )}
      {!(_.isEmpty(description) || canWrite()) && (
        <div className="striped propList__item" data-testid="descriptionDisplayContainer">
          <dt className="mb0 striped">{t('DESCRIPTION')}</dt>
          <dd className="propList__item__value">
            <p className="text-pre-wrap mb5">{description}</p>
          </dd>
        </div>
      )}
    </dl>
  );
};
